import { MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Action, createAction, props } from '@ngrx/store';
import {
  ClientFeeSchedule,
  ClientFeeScheduleApprovalObjectInfo,
  ClientFeeScheduleApprovalStatus,
  FareCalculator,
  Geofence,
  GeofenceCondition,
  GeofenceType,
  OperatingSchedule,
  Organization,
  OrganizationPaymentMethod,
  OrganizationServiceLevel,
  TransitProgram,
  TransitProgramDriver,
  User
} from '@uzurv/clara';
import { ApplicationException, HttpException } from '@uzurv/core';
import { ApprovalRequestStatus } from '../../../../sdk/packages/clara/src/models/approval-request-status';
import { FeeScheduleApprovalRequestSubmission } from '../../../../sdk/packages/clara/src/models/fee-schedule-approval-request-submission';
import { TransitProgramState } from './transit-program.reducer';

export const GetTransitPrograms = createAction('[Transit Program] Get transit programs');

export const GetTransitProgramsSuccess = createAction(
  '[Transit Program] Get transit programs success',
  props<{ transitPrograms: Array<TransitProgram> }>()
);

export const GetTransitProgramsFail = createAction('[Transit Program] Get transit programs fail', props<{ error: HttpException }>());

export const PaginateTransitPrograms = createAction('[Transit Program] Paginate transit programs', props<{ pageEvent: PageEvent }>());

export const ClearSearch = createAction('[Transit Program] Clear search');

export const SearchTransitPrograms = createAction('[Transit Program] Search transit programs', props<{ searchString: string }>());

export const SearchTransitProgramsSuccess = createAction(
  '[Transit Program] Search transit programs success',
  props<{ transitPrograms: Array<TransitProgram> }>()
);

export const SearchTransitProgramsFail = createAction('[Transit Program] Search transit programs fail', props<{ error: HttpException }>());

export const GoToTransitProgram = createAction('[Transit Program] Go to transit program', props<{ transitProgram: TransitProgram }>());

export const GetTransitProgramById = createAction('[Transit Program] Get transit program by id', props<{ transitProgramId: number }>());

export const GetTransitProgramByIdSuccess = createAction(
  '[Transit Program] Get transit program by id success',
  props<{ transitProgram: TransitProgram }>()
);

export const GetTransitProgramByIdFail = createAction(
  '[Transit Program] Get transit program by id fail',
  props<{ error: HttpException }>()
);

export const GetOrganizationServiceLevels = createAction(
  '[Transit Program] Get organization service levels',
  props<{ transitProgram: TransitProgram }>()
);

export const GetOrganizationServiceLevelsSuccess = createAction(
  '[Transit Program] Get organization service levels success',
  props<{ organizationServiceLevels: Array<OrganizationServiceLevel> }>()
);

export const GetOrganizationServiceLevelsFail = createAction(
  '[Transit Program] Get organization service levels fail',
  props<{ error: HttpException }>()
);

export const GetOrganization = createAction('[Transit Program] Get organization');

export const GetOrganizationSuccess = createAction('[Transit Program] Get organization success', props<{ organization: Organization }>());

export const GetOrganizationFail = createAction('[Transit Program] Get organization fail', props<{ error: HttpException }>());

export const EditTransitProgram = createAction('[Transit Program] Edit transit program');

export const CancelEditTransitProgram = createAction('[Transit Program] Cancel edit transit program');

export const SubmitEditTransitProgram = createAction(
  '[Transit Program] Submit edit transit program',
  props<{ transitProgram: TransitProgram }>()
);

export const SubmitEditTransitProgramSuccess = createAction('[Transit Program] Submit edit transit program success');

export const SubmitEditTransitProgramFail = createAction(
  '[Transit Program] Submit edit transit program fail',
  props<{ error: ApplicationException | HttpException }>()
);

export const ShowSubmitEditTransitProgramValidationErrors = createAction(
  '[Transit Program] Show submit edit transit program validation errors',
  props<{ validationErrors: Array<string> }>()
);

export const OpenManageOperatingSchedule = createAction('[Transit Program] Open manage operating schedule');

export const GetTransitProgramDrivers = createAction('[Transit Program] Get transit program drivers');

export const GetTransitProgramDriversSuccess = createAction(
  '[Transit Program] Get transit program drivers success',
  props<{ transitProgramDrivers: Array<TransitProgramDriver> }>()
);

export const GetTransitProgramDriversFail = createAction(
  '[Transit Program] Get transit program drivers fail',
  props<{ error: HttpException }>()
);

export const PaginateTransitProgramDrivers = createAction(
  '[Transit Program] Paginate transit program drivers',
  props<{ pageEvent: PageEvent }>()
);

export const GetGeofenceConditions = createAction('[Transit Program] Get geofence conditions');

export const GetGeofenceConditionsSuccess = createAction(
  '[Transit Program] Get geofence conditions success',
  props<{ geofenceConditions: Array<GeofenceCondition> }>()
);

export const GetGeofenceConditionsFail = createAction('[Transit Program] Get geofence conditions fail', props<{ error: HttpException }>());

export const GetGeofenceTypes = createAction('[Transit Program] Get geofence types');

export const GetGeofenceTypesSuccess = createAction(
  '[Transit Program] Get geofence types success',
  props<{ geofenceTypes: Array<GeofenceType> }>()
);

export const GetGeofenceTypesFail = createAction('[Transit Program] Get geofence types fail', props<{ error: HttpException }>());

export const GetGeofencesForTransitProgram = createAction('[Transit Program] Get geofences for transit program');

export const GetGeofencesForTransitProgramSuccess = createAction(
  '[Transit Program] Get geofences for transit program success',
  props<{ transitProgramGeofences: Array<Geofence> }>()
);

export const GetGeofencesForTransitProgramFail = createAction(
  '[Transit Program] Get geofences for transit program fail',
  props<{ error: HttpException }>()
);

export const UpdateGeofence = createAction('[Transit Program] Update geofence', props<{ geofence: Geofence }>());

export const UpdateGeofenceSuccess = createAction('[Transit Program] Update geofence success', props<{ geofence: Geofence }>());

export const UpdateGeofenceFail = createAction('[Transit Program] Update geofence fail', props<{ error: HttpException }>());

export const AddGeofence = createAction('[Transit Program] Add geofence', props<{ geofence: Geofence }>());

export const AddGeofenceSuccess = createAction('[Transit Program] Add geofence success', props<{ geofence: Geofence }>());

export const AddGeofenceFail = createAction('[Transit Program] Add geofence fail', props<{ error: HttpException }>());

export const DeleteGeofence = createAction('[Transit Program] Delete geofence', props<{ geofenceId: number }>());

export const DeleteGeofenceSuccess = createAction('[Transit Program] Delete geofence success');

export const DeleteGeofenceFail = createAction('[Transit Program] Delete geofence fail', props<{ error: HttpException }>());

export const GetOperatingSchedulesForTransitProgram = createAction('[Transit Program] Get operating schedules for transit program');

export const GetOperatingSchedulesForTransitProgramSuccess = createAction(
  '[Transit Program] Get operating schedules for transit program success',
  props<{ operatingSchedule: Array<OperatingSchedule> }>()
);

export const GetOperatingSchedulesForTransitProgramFail = createAction(
  '[Transit Program] Get operating schedules for transit program fail',
  props<{ error: HttpException }>()
);

export const SetOperatingSchedules = createAction(
  '[Transit Program] Set operating schedules',
  props<{ payload: { operatingSchedule: Array<OperatingSchedule>; dialogRef: MatDialogRef<any> } }>()
);

export const SetOperatingSchedulesSuccess = createAction(
  '[Transit Program] Set operating schedules success',
  props<{ payload: { operatingSchedule: Array<OperatingSchedule>; dialogRef: MatDialogRef<any> } }>()
);

export const SetOperatingSchedulesFail = createAction('[Transit Program] Set operating schedules fail', props<{ error: HttpException }>());

export const GetFareCalculators = createAction('[Transit Program] Get fare calculators');

export const GetFareCalculatorsSuccess = createAction(
  '[Transit Program] Get fare calculators success',
  props<{ fareCalculators: Array<FareCalculator> }>()
);

export const GetFareCalculatorsFail = createAction('[Transit Program] Get fare calculators fail', props<{ error: HttpException }>());

export const GetClientFeeSchedules = createAction(
  '[Transit Program] Get client fee schedules',
  props<{ payload: { transitProgramId: number; serviceLevelId: number } }>()
);

export const GetClientFeeSchedulesSuccess = createAction(
  '[Transit Program] Get client fee schedules success',
  props<{ clientFeeScheduleApprovalStatuses: Array<ClientFeeScheduleApprovalStatus> }>()
);

export const GetClientFeeSchedulesFail = createAction('[Transit Program] Get client fee schedules fail', props<{ error: HttpException }>());

export const DeleteClientFeeSchedule = createAction(
  '[Transit Program] Delete client fee schedule',
  props<{
    payload: {
      transitProgramId: number;
      clientFeeScheduleId: number;
      serviceLevelId: number;
    };
  }>()
);

export const DeleteClientFeeScheduleSuccess = createAction(
  '[Transit Program] Delete client fee schedule success',
  props<{ clientFeeSchedule: ClientFeeSchedule }>()
);

export const DeleteClientFeeScheduleFail = createAction(
  '[Transit Program] Delete client fee schedule fail',
  props<{ error: ApplicationException | HttpException }>()
);

export const ValidateNewClientFeeSchedule = createAction(
  '[Transit Program] Validate new client fee schedule',
  props<{
    payload: {
      transitProgram: TransitProgram;
      transitProgramId: number;
      clientFeeSchedule: ClientFeeSchedule;
      clientFeeScheduleId: number;
    };
  }>()
);

export const UpdateClientFeeScheduleSuccess = createAction(
  '[Transit Program] Update client fee schedule success',
  props<{ clientFeeSchedule: ClientFeeSchedule }>()
);

export const UpdateClientFeeScheduleFail = createAction(
  '[Transit Program] Update client fee schedule fail',
  props<{ error: ApplicationException | HttpException }>()
);

export const CreateNewClientFeeSchedule = createAction(
  '[Transit Program] Create a new client fee schedule in the database',
  props<{
    payload: {
      transitProgramId: number;
      feeScheduleApprovalRequestSubmission: FeeScheduleApprovalRequestSubmission;
      clientFeeScheduleId: number;
    };
  }>()
);

export const CreateNewClientFeeScheduleSuccess = createAction(
  '[Transit Program] Create a new client fee schedule in the database success',
  props<{ clientFeeSchedule: ClientFeeSchedule }>()
);

export const CreateNewClientFeeScheduleFail = createAction(
  '[Transit Program] Create a new client fee schedule in the database fail',
  props<{ error: ApplicationException | HttpException }>()
);

export const SetCurrentTransitProgramSubTab = createAction(
  '[Transit Program] Add or edit a transit program id and sub tab index',
  props<{ payload: { currentTabIndex: number } }>()
);

export const ListUsersByClientApproverRole = createAction(
  '[Transit Program] List users by client approver role',
  props<{ payload: { userId: number } }>()
);

export const ListUsersByClientApproverRoleSuccess = createAction(
  '[Transit Program] List users by client approver role success',
  props<{ usersByClientApproverRole: Array<User> }>()
);

export const ListUsersByClientApproverRoleFail = createAction(
  '[Transit Program] List users by client approver role fail',
  props<{ error: ApplicationException | HttpException }>()
);

export const ListAllApprovalStatuses = createAction('[Transit Program] List all approval statuses');

export const ListAllApprovalStatusesSuccess = createAction(
  '[Transit Program] List all approval statuses success',
  props<{ approvalRequestStatuses: Array<ApprovalRequestStatus> }>()
);

export const ListAllApprovalStatusesFail = createAction(
  '[Transit Program] List all approval statuses fail',
  props<{ error: HttpException }>()
);

export const FindClientFeeScheduleInfoById = createAction(
  '[Transit Program] Find client fee schedule info by id',
  props<{ payload: { transitProgramId: number; clientFeeScheduleId: number } }>()
);

export const FindClientFeeScheduleInfoByIdSuccess = createAction(
  '[Transit Program] Find client fee schedule info by id success',
  props<{ clientFeeScheduleApprovalObjectInfo: ClientFeeScheduleApprovalObjectInfo }>()
);

export const FindClientFeeScheduleInfoByIdFail = createAction(
  '[Transit Program] Find client fee schedule info by id fail',
  props<{ error: HttpException }>()
);

export const FindActiveApproval = createAction(
  '[Transit Program] Find active approval',
  props<{ payload: { approvalId: number; clientFeeScheduleId: number; approvalType: string } }>()
);

export const ApproveClientFeeSchedule = createAction(
  '[Transit Program] Approve client fee schedule',
  props<{ payload: { transitProgramId: number; clientFeeScheduleId: number; clientFeeSchedule: ClientFeeSchedule } }>()
);

export const ApproveClientFeeScheduleSuccess = createAction('[Transit Program] Approve client fee schedule success');

export const ApproveClientFeeScheduleFail = createAction(
  '[Transit Program] Approve client fee schedule fail',
  props<{ error: HttpException }>()
);

export const UpdateApproval = createAction(
  '[Transit Program] Update approval',
  props<{
    payload: {
      transitProgramId: number;
      clientFeeScheduleId: number;
      approvalRequestStatusCode: string;
      reviewNote: string;
      serviceLevelId: number;
    };
  }>()
);

export const UpdateApprovalSuccess = createAction('[Transit Program] Update approval success');

export const UpdateApprovalFail = createAction('[Transit Program] Update approval fail', props<{ error: HttpException }>());

export const UpdateClientFeeSchedule = createAction(
  '[Transit Program] Update client fee schedule',
  props<{
    payload: {
      transitProgramId: number;
      clientFeeScheduleId: number;
      clientFeeSchedule: ClientFeeSchedule;
    };
  }>()
);

export const RejectClientFeeSchedule = createAction(
  '[Transit Program] Reject client fee schedule',
  props<{
    payload: {
      transitProgramId: number;
      clientFeeScheduleId: number;
      clientFeeSchedule: ClientFeeSchedule;
    };
  }>()
);

export const RejectClientFeeScheduleSuccess = createAction('[Transit Program] Reject client fee schedule success');

export const RejectClientFeeScheduleFail = createAction(
  '[Transit Program] Reject client fee schedule fail',
  props<{ error: HttpException }>()
);

export const OpenFeeScheduleChangeRequestDialog = createAction(
  '[Transit Program] Open fee schedule change request dialog',
  props<{
    payload: {
      transitProgramId: number;
      clientFeeSchedule: ClientFeeSchedule;
      clientFeeScheduleId: number;
    };
  }>()
);

export const CancelEditClientFeeSchedule = createAction('[Transit Program] Cancel edit client fee schedule');

export const RestoreState = createAction('[Transit Program] Restore state', props<{ transitProgramState: TransitProgramState }>());

export const ValidateResubmittedClientFeeSchedule = createAction(
  '[Transit Program] Validate resubmitted client fee schedule',
  props<{
    payload: {
      requestorNote: string;
      transitProgram: TransitProgram;
      transitProgramId: number;
      clientFeeSchedule: ClientFeeSchedule;
      clientFeeScheduleId: number;
    };
  }>()
);

export const GetAllTransitPrograms = createAction('[Transit Program] Get all transit programs');

export const GetAllTransitProgramsSuccess = createAction(
  '[Transit Program] Get all transit programs success',
  props<{ transitPrograms: Array<TransitProgram> }>()
);

export const GetAllTransitProgramsFail = createAction('[Transit Program] Get all transit programs fail', props<{ error: HttpException }>());

export const PaginatedSearchTransitPrograms = createAction(
  '[Transit Program] Search paginated transit programs',
  props<{ searchString: string }>()
);

export const PaginatedSearchTransitProgramsSuccess = createAction(
  '[Transit Program] Search paginated transit programs success',
  props<{ transitPrograms: Array<TransitProgram> }>()
);

export const PaginatedSearchTransitProgramsFail = createAction(
  '[Transit Program] Search paginated transit programs fail',
  props<{ error: HttpException }>()
);

export const PaginatedGetOrganizationPayments = createAction(
  '[Transit Program] Get paginated organization payments',
  props<{ id: number }>()
);

export const PaginatedGetOrganizationPaymentsSuccess = createAction(
  '[Transit Program] Get paginated organization payments success',
  props<{ organizationPaymentMethods: Array<OrganizationPaymentMethod> }>()
);

export const PaginatedGetOrganizationPaymentsFail = createAction(
  '[Transit Program] Get paginated organization payments fail',
  props<{ error: HttpException }>()
);

export const TransitProgramMapGetTransitProgramById = createAction(
  '[Transit Program] Get transit program by id from transitProgram map',
  props<{ transitProgramId: number }>()
);
export const TransitProgramMapGetTransitProgramByIdSuccess = createAction(
  '[Transit Program] Get transit program by id from transitProgram map success',
  props<{ transitProgram: TransitProgram }>()
);
export const TransitProgramMapGetTransitProgramByIdFail = createAction(
  '[Transit Program] Get transit program by id from transitProgram map fail',
  props<{ error: HttpException }>()
);

export const TransitProgramMapGetGeoFencesForTransitProgram = createAction(
  '[Transit Program] Get geofences for transit program in the transitProgramMap',
  props<{ transitProgramId: number }>()
);

export const TransitProgramMapGetGeoFencesForTransitProgramSuccess = createAction(
  '[Transit Program] Get geofences for transit program in the transitProgramMap success',
  props<{ transitProgramGeofences: Array<Geofence> }>()
);
